module.exports = __webpack_public_path__ + "assets/images/electoral-college/map/tablet.svg?v=b44a50ce";